/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Org_PoolInputs */

const cs_billing_org_pool = /** @type {(inputs: Billing_Org_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zůstatek poolu`)
};

const en_billing_org_pool = /** @type {(inputs: Billing_Org_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Org pool balance`)
};

/**
* | output |
* | --- |
* | "Org pool balance" |
*
* @param {Billing_Org_PoolInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_org_pool = /** @type {((inputs?: Billing_Org_PoolInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Org_PoolInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_org_pool(inputs)
	return cs_billing_org_pool(inputs)
});